import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { RegisterComponent } from './register.component';
import { RegisterService } from './register.service';

const registerRoutes: Routes = [
  { path: '', component: RegisterComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(registerRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [RegisterService]
})

export class RegisterRoutingModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/register/register.routing.ts